import { z } from "zod";

/**
 * Cor hex `#RRGGBB`.
 *
 * Existia uma cópia deste regex dentro de `agenda-settings.ts` e, do outro lado, os endpoints de
 * estágio de produção validavam a cor como `z.string().max(9)` — que aceita "banana". O valor vai
 * direto pro `style` do card e vira fundo e texto do rótulo: string inválida não explode, ela
 * simplesmente não pinta, e o estágio fica sem cor sem ninguém entender por quê.
 */
export const hexColorSchema = z
  .string()
  .trim()
  .regex(/^#[0-9A-Fa-f]{6}$/, "Cor deve ser hex no formato #RRGGBB");
